<template>
  <div class="info-general-container">
    <div>
      <v-text-field outlined label="Namn" v-model="name"></v-text-field>
      <v-text-field outlined label="Engelskt namn" v-model="englishName"></v-text-field>
      <v-text-field outlined label="Latinskt namn" v-model="latinName"></v-text-field>
      <v-text-field outlined label="Andra namn" v-model="otherName"></v-text-field>
    </div>
    <div>
      <v-text-field outlined label="Storlek" v-model="_size"></v-text-field>
      <v-select
        :items="ArtGroups"
        item-text="name_sve"
        item-value="id"
        v-model="group"
        label="Grupp"
        outlined
      />
      <v-text-field outlined label="Undergrupp" v-model="subGroup"></v-text-field>
      <div class="last">
        <div>
          <v-checkbox
            class="pt-0 mt-0"
            dense
            hide-details
            v-model="featured"
            label="Featured"
          ></v-checkbox>
          <v-checkbox
            dense
            hide-details
            v-model="speciesOfTheWeek"
            label="Veckans art"
          ></v-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ArtGroups } from '@/assets/data/options'

export default {
  name: 'InfoGeneral',
  props: {
    name_sve: { type: String },
    name_eng: { type: String },
    name_lat: { type: String },
    size: { type: String },
    life_cat_id: { type: Number },
    life_group: { type: String },
    life_spec_featured: { type: String },
    life_spec_weekly: { type: String },
  },
  data() {
    return {
      ArtGroups,
    }
  },
  computed: {
    speciesOfTheWeek: {
      get() {
        return this.life_spec_weekly
      },
      set(val) {
        this.$emit('change', { life_spec_weekly: val })
      },
    },
    featured: {
      get() {
        return this.life_spec_featured
      },
      set(val) {
        this.$emit('change', { life_spec_featured: val  })
      },
    },
    _status: {
      get() {
        return this.status
      },
      set(val) {
        this.$emit('change', { status: val })
      },
    },
    subGroup: {
      get() {
        return this.life_group
      },
      set(val) {
        this.$emit('change', { life_group: val })
      },
    },
    group: {
      get() {
        return this.life_cat_id
      },
      set(val) {
        this.$emit('change', { life_cat_id: val })
      },
    },
    _size: {
      get() {
        return this.size
      },
      set(val) {
        this.$emit('change', { size: val })
      },
    },
    otherName: {
      get() {
        return this.name_other_sve
      },
      set(val) {
        this.$emit('change', { name_other_sve: val })
      },
    },
    latinName: {
      get() {
        return this.name_lat
      },
      set(val) {
        this.$emit('change', { name_lat: val })
      },
    },
    englishName: {
      get() {
        return this.name_eng
      },
      set(val) {
        this.$emit('change', { name_eng: val })
      },
    },
    name: {
      get() {
        return this.name_sve
      },
      set(val) {
        this.$emit('change', { name_sve: val })
      },
    },
  },
}
</script>

<style lang="less" scoped>
.info-general-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 15px;
  grid-row-gap: 0px;
  .last {
    display: flex;
    gap: 30px;
  }
}
</style>
